import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { countries, singleCountry } from '../mockData/countries-data';

const CountriesApi = [
  rest.get(`${API_ROOT}countries`, (req, res, ctx) => res(ctx.json(countries))),
  rest.get(`${API_ROOT}countries`, (req, res, ctx) => {
    const countryId = req.url.searchParams.get('countryId');
    if (countryId === singleCountry.id) {
      return res(ctx.json(singleCountry));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}countries`, (req, res, ctx) => res(ctx.json(singleCountry))),
  rest.get(`${API_ROOT}countries_translations/${singleCountry.id}`, (req, res, ctx) => res(ctx.json(singleCountry))),
  rest.delete(`${API_ROOT}countries/${countries[0].id}`, (req, res, ctx) => res(ctx.json(singleCountry))),
  rest.put(`${API_ROOT}countries_translations/${countries[0].id}`, (req, res, ctx) => res(ctx.json(singleCountry))),
];
export default CountriesApi;
